import React, { useEffect } from 'react';
import { useState } from 'react';
import { Outlet } from 'react-router';
import Navbar from '../components/navBar/NavBar';
import Sidebar from '../components/sideBar/SideBar';

const LayoutDashboard = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setDrawerOpen(false);
    }
  }, []);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <main className='flex font-Montserrat leading-[19.49px] min-h-screen w-full'>
      <Sidebar isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
      <div className='flex flex-col w-full '>
        <Navbar isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
        <div className='py-3 px-3 md:p-4'>
          <Outlet />
        </div>
      </div>
    </main>
  );
};

export default LayoutDashboard;
